import { getFavoritesList, addToFavorites, removeFromFavorites, getFavorites } from "@/api/landing";
import { generateRandomGradient } from "@/utils/gradients";

export default {
  namespaced: true,
  
  state: {
    favoritesList: [],
    favorites: {
      data: [],
      pagination: {
        currentPage: 1,
        total: 0,
        perPage: 10,
        lastPage: 1,
        nextPage: null,
      },
    },
    gradients: [],
  },
  
  mutations: {
    SET_FAVORITES_LIST(state, favoritesList) {
      state.favoritesList = favoritesList;
    },
    SET_FAVORITES(state, payload) {
      state.favorites.data = payload.data;
      state.favorites.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
        nextPage: payload.next_page_url,
      };

      if (
        state.gradients.length === 0 ||
        state.gradients.length !== payload.data.length
      ) {
        state.gradients = payload.data.map((_, index) =>
          generateRandomGradient(index)
        );
      }
    },
    ADD_FAVORITE(state, cardId) {
      if (!state.favoritesList.includes(cardId)) {
        state.favoritesList.push(cardId);
      }
    },
    REMOVE_FAVORITE(state, cardId) {
      state.favoritesList = state.favoritesList.filter(id => id !== cardId);
    },
  },
  
  actions: {
    async loadFavoritesList({ commit, rootGetters }) {
      if (!rootGetters['auth/isAuthenticated']) {
        return;
      }
      try {
        const response = await getFavoritesList();
        const favoritesList = response.data.map(item => item.id);
        commit('SET_FAVORITES_LIST', favoritesList);
        return response;
      } catch (error) {
        console.error("Ошибка загрузки избранного:", error);
        throw error;
      }
    },

    async loadFavorites({ commit, rootGetters }, { page = 1, filters = {} } = {}) {
      if (!rootGetters['auth/isAuthenticated']) {
        return;
      }
      return getFavorites({ page, ...filters })
        .then((response) => {
          const favoritesWithBackground = {
            ...response.data,
            data: response.data.data.map((course, index) => ({
              ...course,
              background: generateRandomGradient(index),
            })),
          };
          commit("SET_FAVORITES", favoritesWithBackground);
        })
        .catch((error) => {
          console.error("Ошибка загрузки курсов:", error);
          return Promise.reject(error);
        });
    },
    
    async addToFavorites({ commit, rootGetters }, cardId) {
      if (!rootGetters['auth/isAuthenticated']) {
        throw new Error('Пользователь не авторизован');
      }
      try {
        const response = await addToFavorites(cardId);
        commit('ADD_FAVORITE', cardId);
        return response;
      } catch (error) {
        console.error("Ошибка добавления в избранное:", error);
        throw error;
      }
    },
    
    async removeFromFavorites({ commit, rootGetters }, cardId) {
      if (!rootGetters['auth/isAuthenticated']) {
        throw new Error('Пользователь не авторизован');
      }
      try {
        const response = await removeFromFavorites(cardId);
        commit('REMOVE_FAVORITE', cardId);
        return response;
      } catch (error) {
        console.error("Ошибка удаления из избранного:", error);
        throw error;
      }
    },
  },
  
  getters: {
    getFavorites: (state) => state.favorites,
    getPagination: (state) => state.favorites.pagination,
    favoritesList: (state) => state.favoritesList,
    isFavorite: (state) => (cardId) => state.favoritesList.includes(cardId),
    getGradients: (state) => state.gradients,
  },
};